<!-- src/Components/Welcom/MapSection.vue -->
<template>
    <div class="bg-gray-50 rounded-lg shadow-sm overflow-hidden">
        <iframe :src="mapEmbedUrl" width="100%" height="400" style="border:0; border-radius: 0.5rem" allowfullscreen
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            title="Prefeitura Municipal de Parnaíba no Google Maps" class="w-full"></iframe>
    </div>
</template>

<script setup>
const mapEmbedUrl = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.432818765326!2d-41.7591767!3d-2.9166891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ec3aab2a5d4f3b%3A0xc0fa7c5bd4838426!2sPrefeitura%20Municipal%20de%20Parnaiba!5e0!3m2!1spt-BR!2sbr!4v1733094400000!5m2!1spt-BR!2sbr'
</script>
